// extracted by mini-css-extract-plugin
export var copyableItem = "_n-0";
export var underlined = "_n-1";